import { render } from "./EmptyPage.vue?vue&type=template&id=ecc6c2d0"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/md_tele_vue/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__